export default "__VITE_ASSET__62d177d0__"